var installedModules = {};
var moduleToHandlerMapping = {
	63203: {
		getter: () => (() => (__webpack_require__(85091))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.4.27",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	40074: {
		getter: () => (() => (__webpack_require__(85091))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	83304: {
		getter: () => (() => (__webpack_require__(85091))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.3.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	80117: {
		getter: () => (() => (__webpack_require__(85091))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"14": [
		63203,
		40074
	],
	"21": [
		63203,
		83304,
		40074
	],
	"22": [
		63203
	],
	"25": [
		63203,
		40074
	],
	"27": [
		63203,
		83304
	],
	"39": [
		63203,
		80117,
		83304,
		40074
	],
	"73": [
		63203,
		40074,
		83304
	],
	"77": [
		63203,
		40074
	],
	"96": [
		63203,
		40074
	],
	"110": [
		63203,
		83304
	],
	"121": [
		63203,
		80117,
		83304
	],
	"123": [
		63203,
		83304,
		40074
	],
	"128": [
		63203,
		83304
	],
	"181": [
		63203,
		40074
	],
	"216": [
		63203,
		83304,
		40074
	],
	"237": [
		63203,
		40074,
		83304
	],
	"245": [
		63203,
		80117,
		83304
	],
	"255": [
		63203,
		83304
	],
	"259": [
		63203,
		40074,
		80117
	],
	"285": [
		63203,
		40074,
		83304
	],
	"293": [
		63203,
		40074
	],
	"297": [
		63203,
		40074
	],
	"310": [
		63203,
		80117,
		83304
	],
	"327": [
		63203,
		80117,
		83304,
		40074
	],
	"341": [
		63203,
		40074
	],
	"375": [
		63203,
		40074
	],
	"411": [
		63203,
		83304
	],
	"447": [
		63203,
		83304
	],
	"499": [
		63203,
		80117,
		83304,
		40074
	],
	"515": [
		63203,
		83304,
		40074
	],
	"519": [
		63203,
		80117,
		83304
	],
	"641": [
		63203,
		80117,
		83304,
		40074
	],
	"650": [
		63203,
		40074
	],
	"675": [
		63203,
		40074
	],
	"689": [
		63203,
		40074
	],
	"692": [
		63203,
		40074,
		83304
	],
	"708": [
		63203,
		83304,
		40074
	],
	"727": [
		63203,
		40074
	],
	"748": [
		63203,
		83304,
		40074
	],
	"764": [
		63203,
		40074,
		83304
	],
	"793": [
		63203,
		83304,
		40074
	],
	"877": [
		63203,
		83304
	],
	"890": [
		63203,
		40074
	],
	"945": [
		63203,
		40074,
		83304
	],
	"975": [
		63203,
		80117,
		83304
	],
	"983": [
		63203,
		80117,
		83304
	],
	"991": [
		63203,
		80117,
		83304
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}